import { useToastStore } from "../../../stores/toastStore";
import type { ToastType } from "./Toast";

type CustomToastType = ToastType | "error";

export function showToast(type: CustomToastType, message: string, title?: string) {
  const toastType: ToastType = type === "error" ? "warning" : type;
  const defaultTitle =
    toastType === "success"
      ? "Success"
      : toastType === "warning"
        ? "Warning"
        : "Critical";

  useToastStore.getState().addToast({
    type: toastType,
    title: title ?? defaultTitle,
    message,
    duration: 5000,
  });
}
